<template>
  <div>
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <div class="siteInformation">
      <div class="siteInforInner" v-for="(item,index) in userList" :key="index">
        {{item.key+':'+item.value}}
      </div>
    </div>
  </div>
</template>

<script>
import BigTitle from '@/components/bigTitle';

export default {
  data () {
    return {
      options: {},

    };
  },
  components: {
    BigTitle
  },
  props: {
    bigtitle:{
      type: Object,
      default: () => ({})
    },
    userList: {
      type: Array,
      default: () => ({})
    },
  },
  watch: {
    
  },
}
</script>
<style lang="scss">
.siteInformation{
  display:grid;
  grid-template-columns:250px 250px;
  margin-bottom:15px;
}
.siteInforInner{
  // width:250px;
  // height:52px;
  line-height: 52px;
  background:rgba(1,177,169,.3);
  color:#fff;
  font-size:18px;
  margin-right: 10px;
  margin-bottom:3px;
  padding-left:13px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
}
</style>